import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "c-single-car-payments__wrapper" }
const _hoisted_2 = { class: "c-single-car-payments" }
const _hoisted_3 = {
  key: 0,
  class: "c-single-car-payments__discount__wrapper"
}
const _hoisted_4 = { class: "c-single-car-payments__discount" }
const _hoisted_5 = { class: "c-single-car-payments__toggle__wrapper" }
const _hoisted_6 = { class: "c-single-car-payments__toggle" }
const _hoisted_7 = { class: "c-single-car-payments__toggle__label__wrapper" }
const _hoisted_8 = { class: "c-single-car-payments__expend-boxes__inner" }
const _hoisted_9 = { class: "c-single-car-payments-content__select" }
const _hoisted_10 = { class: "o-select__wrap" }
const _hoisted_11 = { class: "o-select__wrap" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "c-single-car-financement" }
const _hoisted_14 = { class: "c-single-car-payments-content__row" }
const _hoisted_15 = { class: "c-single-car-payments-content__price" }
const _hoisted_16 = {
  key: 0,
  class: "c-single-car-payments-content__row"
}
const _hoisted_17 = { class: "c-single-car-payments-content__discount" }
const _hoisted_18 = { class: "c-single-car-payments-content__row" }
const _hoisted_19 = { class: "o-input__wrap" }
const _hoisted_20 = { class: "c-single-car-payments-content__row" }
const _hoisted_21 = { class: "c-single-car-payments-content__taxes" }
const _hoisted_22 = { class: "c-single-car-payments-content__taxes__radio" }
const _hoisted_23 = { class: "c-single-car-payments-content__taxes__label" }
const _hoisted_24 = { class: "c-single-car-payments-content__taxes__row" }
const _hoisted_25 = { class: "c-single-car-payments-content__price" }
const _hoisted_26 = { class: "c-single-car-payments-content__price" }
const _hoisted_27 = { class: "c-single-car-payments-content__row" }
const _hoisted_28 = { class: "o-input__wrap" }
const _hoisted_29 = { class: "c-single-car-payments-content__row -total" }
const _hoisted_30 = { class: "c-single-car-payments-content__label" }
const _hoisted_31 = { class: "c-single-car-payments-content__price" }
const _hoisted_32 = { class: "c-single-car-comptant" }
const _hoisted_33 = { class: "c-single-car-payments-content__row" }
const _hoisted_34 = { class: "c-single-car-payments-content__price" }
const _hoisted_35 = {
  key: 0,
  class: "c-single-car-payments-content__row"
}
const _hoisted_36 = { class: "c-single-car-payments-content__discount" }
const _hoisted_37 = { class: "c-single-car-payments-content__row" }
const _hoisted_38 = { class: "o-input__wrap" }
const _hoisted_39 = { class: "c-single-car-payments-content__row" }
const _hoisted_40 = { class: "c-single-car-payments-content__taxes" }
const _hoisted_41 = { class: "c-single-car-payments-content__taxes__radio" }
const _hoisted_42 = { class: "c-single-car-payments-content__taxes__label" }
const _hoisted_43 = { class: "c-single-car-payments-content__taxes__row" }
const _hoisted_44 = { class: "c-single-car-payments-content__price" }
const _hoisted_45 = { class: "c-single-car-payments-content__price" }
const _hoisted_46 = { class: "c-single-car-payments-content__row -total" }
const _hoisted_47 = { class: "c-single-car-payments-content__price" }
const _hoisted_48 = { class: "c-single-car-payments__expend-button__wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")
  const _component_Note = _resolveComponent("Note")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "c-single-car-payments__title__wrapper" }, [
        _createElementVNode("h2", { class: "c-single-car-payments__title" }, "Estimez vos paiements")
      ], -1 /* HOISTED */)),
      (_ctx.$root.rebate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "Rabais de " + _toDisplayString(_ctx.cash(_ctx.$root.rebate)), 1 /* TEXT */),
            _createVNode(_component_svgIco, { icon: "price-tag-fill" })
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.$root.hasFinance)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["c-single-car-payments__toggle__button", {'-is-active': _ctx.$root.type=='finance', '-is-expend': _ctx.$root.expanded}]),
                onClick: _cache[0] || (_cache[0] = $event => {_ctx.$root.type='finance'; _ctx.$root.expanded = true})
              }, _toDisplayString(_ctx.cents($options.finance)), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: _normalizeClass(["c-single-car-payments__toggle__button", {'-is-active': _ctx.$root.type=='cash', '-is-expend': _ctx.$root.expanded}]),
            onClick: _cache[1] || (_cache[1] = $event => {_ctx.$root.type='cash'; _ctx.$root.expanded = true})
          }, _toDisplayString(_ctx.cash($options.subtotalCash + $options.tps + $options.tvq)), 3 /* TEXT, CLASS */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.$root.hasFinance)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["c-single-car-payments__toggle__label", {'-is-active': _ctx.$root.type=='finance'}]),
                "data-active": "financement"
              }, "Financement", 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", {
            class: _normalizeClass(["c-single-car-payments__toggle__label", {'-is-active': _ctx.$root.type=='cash'}]),
            "data-active": "comptant"
          }, "Comptant", 2 /* CLASS */)
        ])
      ])
    ]),
    (_ctx.$root.expanded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["c-single-car-payments__expend-boxes", {'-is-expend': _ctx.$root.expanded}])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" Financement "),
            (_ctx.$root.hasFinance)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["c-single-car-payments__expend__financement", {'-is-active': _ctx.$root.type=='finance'}])
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.$root.select) = $event))
                      }, _cache[11] || (_cache[11] = [
                        _createElementVNode("option", { value: "weekly" }, "Par semaine", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "biweekly" }, "Aux 2 semaines", -1 /* HOISTED */),
                        _createElementVNode("option", { value: "monthly" }, "Mensuel", -1 /* HOISTED */)
                      ]), 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.$root.select]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.$root.term) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.percents, (item, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: key
                          }, _toDisplayString(key) + " mois / " + _toDisplayString(_ctx.pct(item)), 9 /* TEXT, PROPS */, _hoisted_12))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.$root.term]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Prix du véhicule", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.cash(_ctx.$root.price+_ctx.$root.rebate)), 1 /* TEXT */)
                    ]),
                    (_ctx.$root.rebate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Rabais du concessionnaire", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_17, "-" + _toDisplayString(_ctx.cash(_ctx.$root.rebate)), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez une valeur d’échange :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.$root.exchange) = $event)),
                          placeholder: "0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.$root.exchange,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: "1",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.$root.includeTaxes) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, _ctx.$root.includeTaxes]
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("span", null, "Inclure les taxes", -1 /* HOISTED */))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TPS :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.cents($options.tps)), 1 /* TEXT */),
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TVQ :", -1 /* HOISTED */)),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.cents($options.tvq)), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez un versement initial :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "o-input o-input-smaller",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.$root.initialCash) = $event)),
                          placeholder: "0,00 $"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            _ctx.$root.initialCash,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, "Votre paiement par " + _toDisplayString($options.term), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.cents($options.finance)), 1 /* TEXT */)
                    ])
                  ]),
                  _createVNode(_component_Note)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Comptant "),
            _createElementVNode("div", {
              class: _normalizeClass(["c-single-car-payments__expend__comptant", {'-is-active': _ctx.$root.type=='cash'}])
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "c-single-car-payments-content__select" }, null, -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Prix du véhicule", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.cash(_ctx.$root.price+_ctx.$root.rebate)), 1 /* TEXT */)
                ]),
                (_ctx.$root.rebate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Rabais du concessionnaire", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_36, "-" + _toDisplayString(_ctx.cash(_ctx.$root.rebate)), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_37, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Ajoutez une valeur d’échange :", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "o-input o-input-smaller",
                      placeholder: "0,00 $",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.$root.exchange) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.$root.exchange]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: "1",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.$root.includeTaxes) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.$root.includeTaxes]
                        ]),
                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "Inclure les taxes", -1 /* HOISTED */))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TPS :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.cents($options.tps)), 1 /* TEXT */),
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "TVQ :", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.cents($options.tvq)), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "c-single-car-payments-content__label" }, "Votre paiement", -1 /* HOISTED */)),
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.cash($options.subtotalCash + $options.tps + $options.tvq)), 1 /* TEXT */)
                ])
              ]),
              _createVNode(_component_Note)
            ], 2 /* CLASS */)
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("button", {
        class: _normalizeClass(["c-single-car-payments__expend-button", {'-is-active': _ctx.$root.expanded}]),
        onClick: _cache[9] || (_cache[9] = $event => (_ctx.$root.expanded = !_ctx.$root.expanded))
      }, [
        _createVNode(_component_svgIco, { icon: "arrow-down-slim" })
      ], 2 /* CLASS */)
    ])
  ]))
}